import { render, staticRenderFns } from "./QuestionViewPage.vue?vue&type=template&id=190b4866&"
import script from "./QuestionViewPage.vue?vue&type=script&lang=js&"
export * from "./QuestionViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports